import type { ReactNode } from 'react';
import { useEffect } from 'react';
import {
  SaveShortcutBoundary,
  type SaveShortcutStrategy,
} from '@src/shared/ui/SaveShortcutScope';
import { useMainContext } from '../MainContext';
import Layout from './Layout';
import PageLayoutProvider from './provider';

type PageProps = {
  children: ReactNode;
  fillHeight?: boolean;
  scrollable?: boolean;
  shortcutStrategy?: SaveShortcutStrategy;
};

export default function Page({
  children,
  fillHeight = false,
  scrollable = false,
  shortcutStrategy = 'all',
}: PageProps) {
  const { setScrollable } = useMainContext();

  useEffect(() => {
    setScrollable(scrollable);
    return () => setScrollable(false);
  }, [scrollable, setScrollable]);

  return (
    <PageLayoutProvider>
      <SaveShortcutBoundary priority="page" strategy={shortcutStrategy}>
        <Layout fillHeight={fillHeight}>{children}</Layout>
      </SaveShortcutBoundary>
    </PageLayoutProvider>
  );
}
